import React, { useEffect, useRef } from "react";

function OutsideClick({ setToggled, children, className = "", key = "" }) {
  const componentRef = useRef(null);

  const handleOutsideClick = (event) => {
    if (
      componentRef.current &&
      !componentRef.current.contains(event.target)
      &&
      !event.target.closest(".navLinks") &&
      !event.target.closest(".menuItemDiv")
    ) {
      setTimeout(() => {
        // console.log("outsideclick");
        setToggled(false);
      }, 1);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);
  return (
    <div key={key} className={`${className} OutsideClickContainer`} ref={componentRef}>
      {children}
    </div>
  );
}

export default OutsideClick;
